class Header {
    constructor() {
        this.container  = document.querySelector('.header-main');

        // only if header exists
        if (this.container) {
            this.logo       = {
                container:  {
                    wrap:   this.container.querySelector('.header-logo'),
                    image:  this.container.querySelector('.header-logo img'),
                },
            };
            this.display    = {
                active:     true,
                allowed:    true,
            };
            this.scroll     = {
                last:           0,
                start:          50,
                timing:         66,
                turningPoint:   150,
                autoHide:       false,
                context:        window,
                class:          'hide',
            };
            this.branding   = {
                show:       true,
                container:  {
                    wrap: this.container.querySelector('.branding'),
                },
            };

            App.wait('App.Brand.identifier', brand => {
                this.setBrand(brand);
            });
            this.bind();

        }
    }

    hide() {
        // Hide only if hiding is enable
        if (this.display.active) this.container.classList.add(this.scroll.class);
    }

    show() {
        this.container.classList.remove(this.scroll.class);
    }

    showLogo(display = true) {
        display ? this.container.classList.add('show-logo') : this.container.classList.remove('show-logo');
    }

    showBrands(display = true) {
        // @todo: this fix only as long as the IOS App loads header JS
        if (!this.container) return this;
        this.branding.show = display;
        return this;
    }

    toggleVisibility(display) {
        if (display !== this.display.allowed) {
            display ? this.show() : this.hide();
        }
    }

    disableHiding() {
        this.display.active = false;
        return this;
    }

    allowHiding(allow) {
        this.scroll.active = allow;
        if(!allow) this.show();
    }

    bind() {
        this.scroll.context.addEventListener('scroll', () => {
            this.update();
        }, {passive: true});
        this.logo.container.wrap.addEventListener('touchstart', event => {
            event.target.classList.add('touch');
        }, {passive: true});
        this.logo.container.wrap.addEventListener('touchend', event => {
            event.target.classList.remove('touch');
        }, {passive: true});
        this.logo.container.wrap.addEventListener('click', event => {
            let href = event.target.getAttribute('href');
            if (href === window.location.href ||  href === window.location.pathname) {
                event.preventDefault();
                App.Layout.setPosition(0, App.Setting('FX_DURATION_SHORT'));
            }
        });

    }

    setBrand(brand) {
        brand = App.Data.getConfiguration('brands')[brand];
        if (brand === undefined) return;
        this.logo.container.image.src = brand.images.menu;
        this.logo.container.image.atl = brand.name;
        this.logo.container.wrap.href = brand.url;
    }

    update() {
        // @todo: this fix only as long as the IOS App loads header JS
        if (!this.container) return this;

        let scrollTop           = window.scrollY;
        let reachedTurningPoint = scrollTop > this.scroll.start;
        let overScroll          = scrollTop > this.scroll.last;
        let preventOverscroll   = scrollTop > this.scroll.turningPoint;
        let autoHide            = (!(overScroll && preventOverscroll && this.scroll.autoHide));

        this.toggleVisibility(autoHide);

        /* Logo */
        let showLogo;
        if (this.branding.show) {
            this.container.classList.add('show-brands');
            showLogo = reachedTurningPoint;
        } else {
            this.container.classList.remove('show-brands');
            showLogo = true;
        }
        this.showLogo(showLogo);

        this.display.allowed    = autoHide;
        this.scroll.last        = scrollTop;
    }
}

App.Layout.Header = new Header();
